import { type ReactElement } from 'react';
import { useShow } from '@refinedev/core';
import { Show } from '@refinedev/antd';
import { Descriptions, Tag, Grid } from 'antd';

import type { AdminConsentLog } from '@/types';

const { useBreakpoint } = Grid;

const CONSENT_TYPE_COLORS: Record<string, string> = {
  tos: 'blue',
  privacy_policy: 'purple',
  biometric: 'orange',
  marketing: 'green',
};

export function ConsentLogShow(): ReactElement {
  const { query } = useShow<AdminConsentLog>();
  const record = query.data?.data;
  const isLoading = query.isLoading;

  const screens = useBreakpoint();
  const descColumns = screens.md ? 2 : 1;

  return (
    <Show isLoading={isLoading}>
      {record && (
        <Descriptions bordered column={descColumns} size="small">
          <Descriptions.Item label="ID">{record.id}</Descriptions.Item>

          <Descriptions.Item label="Customer">
            {record.customerId ? (
              <a href={`/customers/show/${record.customerId}`}>
                {record.customerId}
              </a>
            ) : (
              '—'
            )}
          </Descriptions.Item>

          <Descriptions.Item label="Order">
            {record.orderId ? (
              <a href={`/orders/show/${record.orderId}`}>{record.orderId}</a>
            ) : (
              '—'
            )}
          </Descriptions.Item>

          <Descriptions.Item label="Consent Type">
            <Tag color={CONSENT_TYPE_COLORS[record.consentType] ?? 'default'}>
              {record.consentType}
            </Tag>
          </Descriptions.Item>

          <Descriptions.Item label="Consent Version">
            {record.consentVersion}
          </Descriptions.Item>

          <Descriptions.Item label="Consent Given">
            {record.consentGiven ? (
              <Tag color="green">✓ Yes</Tag>
            ) : (
              <Tag color="red">✗ No</Tag>
            )}
          </Descriptions.Item>

          <Descriptions.Item label="IP Address">
            {record.ipAddress ?? '—'}
          </Descriptions.Item>

          <Descriptions.Item label="User Agent" span={descColumns}>
            {record.userAgent ?? '—'}
          </Descriptions.Item>

          <Descriptions.Item label="Notice Text Hash" span={descColumns}>
            {record.noticeTextHash ?? '—'}
          </Descriptions.Item>

          <Descriptions.Item label="Created At">
            {new Date(record.createdAt).toLocaleString()}
          </Descriptions.Item>
        </Descriptions>
      )}
    </Show>
  );
}
